var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7794_56453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7794_56453)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.585786,
    width: 16.1836,
    height: 16.1836,
    transform: "rotate(45 12 0.585786)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5858 0.6127H13.4142L23.4435 10.642V13.4704L13.4142 23.4997H10.5858L0.55649 13.4704V10.642L10.5858 0.6127ZM12 2.02691L1.9707 12.0562L12 22.0855L22.0293 12.0562L12 2.02691Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.002,
    cy: 7.28392,
    r: 1.66746,
    transform: "rotate(45 12.002 7.28392)",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.7109,
    cy: 11.9988,
    r: 1.66746,
    transform: "rotate(45 16.7109 11.9988)",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.998,
    cy: 16.7136,
    r: 1.66746,
    transform: "rotate(45 11.998 16.7136)",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.28516,
    cy: 11.9988,
    r: 1.66746,
    transform: "rotate(45 7.28516 11.9988)",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.484a09d0f6045d36ce2f8bdee9139a1a.svg";
export { ForwardRef as ReactComponent };